export default {
  name: "BolideAssistantHistoryItem",

  props: {
    conversation: {
      type: Object,
      required: true,
    },
    is_active: Boolean,
    can_delete: Boolean,
  },

  emits: ["select", "delete"],

  computed: {
    conversation_title() {
      const first_user_message = this.conversation.messages?.find((msg) => msg.sender === "user");
      return first_user_message?.text || this.conversation.title || "New conversation";
    },

    conversation_preview() {
      const last_message = this.conversation.messages?.[this.conversation.messages.length - 1];
      return last_message?.text || this.conversation.preview || "No messages yet";
    },

    conversation_timestamp_value() {
      return this.conversation.updated_at
        || this.conversation.messages?.[this.conversation.messages.length - 1]?.created_at
        || this.conversation.created_at;
    },

    conversation_timestamp() {
      const date = this.conversation_timestamp_date;
      if (!date) {
        return "";
      }

      return new Intl.DateTimeFormat(undefined, {
        weekday: "long",
        day: "numeric",
        month: "short",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      }).format(date);
    },

    conversation_timestamp_date() {
      const date_value = this.conversation_timestamp_value;
      if (!date_value) {
        return null;
      }

      const date = new Date(date_value);
      if (Number.isNaN(date.getTime())) {
        return null;
      }

      return date;
    },

    conversation_date_label() {
      const date = this.conversation_timestamp_date;
      if (!date) {
        return "";
      }

      return new Intl.DateTimeFormat(undefined, {
        weekday: "long",
        day: "numeric",
        month: "short",
      }).format(date);
    },
  },
};
